
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/usePageVisibility.html",
      function () {
        return require("private-next-pages/Hooks/usePageVisibility.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/usePageVisibility.html"])
      });
    }
  